import Client from './Clients/AxiosClient';
import { apiRefusal } from '../utils/apiError';
const resource = '/api/Staff';

export default {
  // Every filter is optional and they combine. Ids are sent as 0 and terms as empty when the
  // corresponding filter is not set, which is what the API reads as "leave this one out".
  getStaffs(
    lazyParams,
    searchFilterbyOutlet,
    searchFilterbyContact,
    searchFilterbyPosition,
    searchFilterbyUserName,
  ) {
    return Client.get(
      `${resource}/filter-by-outlet/${searchFilterbyOutlet?searchFilterbyOutlet.id:0}`,
      {
        params: {
          skipCount: lazyParams.first,
          takeCount: lazyParams.rows,
          searchFilterbyContact: searchFilterbyContact,
          searchFilterbyPosition: searchFilterbyPosition
            ? searchFilterbyPosition.id
            : 0,
          searchFilterbyUserName: searchFilterbyUserName,
        },
      },
    );
  },
  // Two calls, and the second must not happen unless the first succeeded. It used to be
  // chained with .then() off a client that resolves failures instead of rejecting them, so a
  // refused registration - the user name is already taken - fell straight through into
  // creating the staff row against the account that already existed. That is how one branch
  // administrator ended up with two staff records sharing a single login.
  async createStaff(staff, regAuth) {
    const registration = await Client.post(
      `/api/Authentication/register`,
      regAuth,
    );
    const registrationRefused = apiRefusal(registration);
    if (registrationRefused) {
      throw registrationRefused;
    }

    const created = await Client.post(`${resource}`, {
      staff: staff,
      counter: staff.counter,
    });
    const creationRefused = apiRefusal(created);
    if (creationRefused) {
      throw creationRefused;
    }
    return created;
  },
  // updateStaff(payload) {
  //   return Client.put(`${resource}/Staff/${payload.id}`, payload);
  // },

  async updateStaff(staff) {
    //This is necessary! Check why there is technicalServices key in Staff and remove it!. The json data also need to be minimize.
    // Otherwise, .net will receive null.
    staff.technicalServices = null;
    staff.counterToStaffAdjustmentLogs = [];
    staff.value = null;
    return await Client.put(`${resource}/${staff.id}`, {
      staff: staff,
      counter: staff.counter,
    });
  },
  getCounterGroups(lazyParams) {
    return Client.get(`/api/CounterGroup`, {
      params: {
        skipCount: lazyParams.first,
        takeCount: lazyParams.rows,
        filterGroupbyOutletId: lazyParams.filterGroupbyOutletId,
      },
    });
  },
  async createCounterGroup(counterGroup) {
    // We dont use this because of can't find a consistent algotithm to alter state.counters with new changes
    return await Client.post(`/api/CounterGroup`, {
      counterGroup: counterGroup,
      counters: counterGroup.counters,
      walkinServiceTypes: counterGroup.walkinServiceTypes,
    });
    // return Client.post(`/api/CounterGroup`, { counterGroup: counterGroup, counters: counterGroup.counters, walkinServiceTypes: counterGroup.walkinServiceTypes }).then(async function () {
    //   return await Client.get(`/api/CounterGroup`)
    //     .then(function (response) {
    //       return response;
    //     });
    // });
  },
  async updateCounterGroup(counterGroup, lazyParams) {
    // We dont use this because of can't find a consistent algotithm to alter state.counters with new changes
    // return await Client.put(`/api/CounterGroup`, {counterGroup:counterGroup, counters:counterGroup.counters, walkinServiceTypes:counterGroup.walkinServiceTypes});
    return Client.put(`/api/CounterGroup`, {
      counterGroup: counterGroup,
      counters: counterGroup.counters,
      walkinServiceTypes: counterGroup.walkinServiceTypes,
    }).then(async function() {
      return await Client.get(`/api/CounterGroup`, {
        params: {
          skipCount: lazyParams.first,
          takeCount: lazyParams.rows,
          filterGroupbyOutletId: lazyParams.filterGroupbyOutletId,
        },
      }).then(function(response) {
        return response;
      });
    });
  },

  //Two Layers
  getOutlets() {
    return Client.get(`/api/Outlet`);
  },
  getOutletsOnly(payload) {
    return Client.get(`/api/Outlet/only/${payload.organizationId}`);
  },
  async createOutlet(outlet) {
    return await Client.post(`/api/Outlet`, {
      outlet: outlet,
      totalCounters: outlet.totalCounters,
    });
  },
  async updateOutlet(outlet) {
    return await Client.put(`/api/Outlet/${outlet.id}`, {
      outlet: outlet,
      totalCounters: outlet.totalCounters,
    });
  },

  //Three layers
  async getCounters(payload) {
    return await Client.get(`/api/Counter/by-outlet/${payload.id}`);
  },

  //One layer
  getOrganizations() {
    return Client.get(`/api/Organization`);
  },
  getWalkinServiceTypes() {
    return Client.get(`/api/WalkinServiceType`);
  },
  getStaffPositions() {
    return Client.get(`/api/StaffPosition`);
  },
  // delete(id) {
  //   return Client.delete(`${resource}/${id}`);
  // },

  // MANY OTHER ENDPOINT RELATED STUFFS
};
